<template>
  <div class="ProductForm__Actions">
    <div class="ProductForm__ActionWrap">
      <div class="ProductForm__Cta--Container">
        <button role="button" class="ProductForm__Cta" data-ht-element="cta" @click="toggleModal">
          {{ terms.atc }}
        </button>
      </div>
    </div>
    <p class="p5 ProductForm__CtaCaption">{{ terms.atc_sub }}</p>
  </div>
  <TransitionGroup>
    <div v-if="showModal" class="BackInStockModal" @click="toggleModal"></div>
    <div v-if="showModal" class="BackInStockModal__Content" :class="{ 'BackInStockModal__Content--Successful': successful }">
      <section v-if="!successful">
        <Icon :icon="'close'" :class="'BackInStockModal__Close'" @click="toggleModal" />
        <div class="BackInStockModal__Header">
          <p class="t2">{{ terms.modal.header }}</p>
        </div>
        <div class="BackInStockModal__Caption">
          <span class="p4">{{ terms.modal.caption }}</span>
        </div>
        <input v-model="email" type="text" class="BackInStockModal__Input" :class="{ 'BackInStockModal__Input--Error': !valid }" :placeholder="terms.modal.email_placeholder" />
        <div class="BackInStockModal__ValidationError">
          <span v-if="!valid" class="p6">{{ terms.modal.error }}</span>
        </div>
        <div class="BackInStockModal__Legal">
          <p class="p6">{{ terms.modal.legal }}</p>
        </div>
        <div class="BackInStockModal__CtaContainer">
          <button class="button button--tertiary-b BackInStockModal__Cta" :class="{ 'button--inactive': email.length <= 0 }" ref="submit" @click="handleSubmit">{{ terms.modal.cta }}</button>
        </div>
      </section>
      <section v-else>
        <div class="BackInStockModal__Header">
          <p class="t2">{{ terms.modal.success }}</p>
          <Icon :icon="'close'" :class="'BackInStockModal__Close'" @click="toggleModal" />
        </div>
        <div class="BackInStockModal__Caption">
          <span class="p4">{{ terms.modal.caption }}</span>
        </div>
      </section>
    </div>
  </TransitionGroup>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import { setSwymCallback } from '@utils/VendorSwym';
import { useProductStore } from './Composables/Store';
import { pubSub } from '@utils/PubSub';
import { formatID } from '@utils/format';
import Icon from '../Global/Icon.vue';

const showModal = ref(false);
const email = ref('');
const valid = ref(true);
const submit = ref(null);
const successful = ref(false);
const terms = ref({});

const props = defineProps({
  qvData: { type: Object, required: false },
  location: { type: String, required: false },
});

const store = useProductStore();
const { $state } = store;
terms.value = $state.terms.back_in_stock;

// Swym-specific Variables
const subscribeEvent = 'swym:subscribe';
const medium = 'email';
const variantId = props.location == 'quick-view' ? formatID(props.qvData.variantId) : formatID($state.selected.variant.id);
const productId = props.location == 'quick-view' ? formatID(props.qvData.productId) : formatID($state.selected.variant.product.id);
const url = props.location == 'quick-view' ? props.qvData.url : $state.item.onlineStoreUrl;
const img = props.location == 'quick-view' ? props.qvData.img : $state.gallery[0].image.url;
const price = props.location == 'quick-view' ? props.qvData.price : parseFloat($state.item.priceRange.minVariantPrice);
const eventType = 8;

// Swym's required format for the subscription payload
const swymProduct = {
  epi: variantId, // unique variant ID of the product.
  empi: productId, // Product ID or master product ID
  du: url, // canonical product url.
  iu: img, // image url for email
  pr: price, // price
  et: eventType, // event type 8 stands for registering a "notify me" event.
};

// Callback for successful subscription
const onSuccess = (response) => {
  valid.value = true;
  successful.value = true;
  console.log(response.message);
};

// Callback for unsuccessful subscription
const onError = (error) => {
  valid.value = true;
  successful.value = false;
  throw new Error(`Swym Subscribe failed: ${error}`);
};

const handleSubmit = () => {
  const regExPattern = /^\w+([.-]\w+)*@\w+([.-]\w+)*(\.\w{2,4})+$/;
  const isValid = email.value.match(regExPattern);
  valid.value = isValid;

  if (isValid) {
    pubSub.publish(subscribeEvent);
  }
};

const subscribe = (swat) => {
  pubSub.subscribe('swym:subscribe', () => {
    swat.sendWatchlist(email.value, medium, swymProduct, onSuccess, onError, 1);
  });
};

const toggleModal = () => (showModal.value = !showModal.value);

onMounted(() => {
  setSwymCallback(subscribe);
});
</script>
